angular.module('wbDashboard').controller('ProfileCloseAccountControllerAurea', ['$scope', '$q', '$uibModal', 'User', 'Message', function ($scope, $q, $uibModal, User, Message) {

    $scope.closeAccount = {};
    $scope.closeReasons = [];

    //retrieve again just in case something changed and it's no longer closable
    User.retrieveDetail(true);
    $scope.$watch(User.getDetail, function(detail) {
        if (detail) {
            if (!detail.closable.is_closable) {
                Message.add({
                    key: 'user-close',
                    text: detail.closable.reason,
                    type: 'warning'
                });
                $scope.$state.go("base.overview");
            } else if (detail.closable.reasons) {
                $scope.closeReasons = shuffleArray(detail.closable.reasons.slice(0));
            }
        }
    });

    $scope.openCloseAccountConfirm = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'modal-confirm-user-close.tpl.html',
            scope:$scope,
            size: 'md',
            windowClass:'confirm-modal modal-close-wb'
        });

        modalInstance.result.then(function (selectedItem) {
            $scope.pageData.sending = true;

            User.closeUser({
                answer:$scope.closeAccount.reason,
                response: $scope.closeAccount.description
            }).then(function(response) {
                var overview = User.getOverview();
                if (overview && "user" in overview) {
                    //so the overview will display the closed while it's still updating the new overview request
                    overview.user.is_closed = true;
                }

                Message.add({
                    key: 'user-close',
                    text: 'Account closure has been successfully initiated',
                    type: 'success'
                });
                //force reload of all parent controllers will reload base controller
                //which will update overview, milestones, and fundingActivity
                $scope.$state.go("base.overview", {}, { reload: true });
            }).catch(function(err) {
                var msg = "Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.";
                if (err && err.data && err.data.error && err.data.error.message) {
                    msg = err.data.error.message;
                }
                Message.set({
                    text: msg,
                    type: "danger"
                });
            }).finally(function () {
                $scope.pageData.sending = false;
            });

        }).catch(angular.noop); //dismissed/cancelled


    };

    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm.
     *
     * @param array
     * @returns {*}
     */
    function shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }

    function checkPage(page) {
        return page == 'start' || ($scope.closeAccount.reason && $scope.closeAccount.description);
    }
    if (!checkPage($scope.$stateParams.page)) {
        $scope.$state.go('base.profile.close.steps', {page: 'start'});
    }

    var transitionDeregisterHook = $scope.$transitions.onStart({ to: "base.profile.close.steps" }, function(trans) {
        var page = trans.params('to').page;
        if (!checkPage(page)) {
            return trans.router.stateService.target('base.profile.close.steps', {page: 'start'});
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
